/* SmartLinkSourceRow.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._5ral1f51%7B-o-object-fit%3Acontain%3Bobject-fit%3Acontain%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i7vkz%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb7vkz%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1o8l%7Bdisplay%3Ainline-block%7D");
import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { type ProviderIcon, useSmartLinkMetadata } from './useSmartLinkMetadata';
type SmartLinkSourceRowProps = {
  /** The URL to resolve via the SmartLink store. */
  url: string;
  /** Shown while resolving or when resolution fails. */
  fallback: string;
  /**
   * Optional user-provided display text (e.g. the value the user typed into
   * the link picker's "Display text" field). When set and non-empty, it
   * takes precedence over the SmartLink-resolved title and the `fallback`.
   * The provider icon is still resolved from the SmartLink store.
   */
  displayTextOverride?: string;
};
const providerIconImageStyles = null;
const ProviderIconView = ({
  icon
}: {
  icon: ProviderIcon | undefined;
}) => {
  if (!icon) {
    return null;
  }
  if (icon.kind === 'url') {
    return <img src={icon.url} alt="" className={ax(["_1e0c1o8l _1bsb7vkz _4t3i7vkz _5ral1f51"])} />;
  }
  return <React.Fragment>{icon.node}</React.Fragment>;
};
export const SmartLinkSourceRow = ({
  url,
  fallback,
  displayTextOverride
}: SmartLinkSourceRowProps): React.JSX.Element => {
  const {
    title,
    providerIcon,
    status
  } = useSmartLinkMetadata(url);

  // While resolving, prefer to show the user-provided display text immediately
  // (with no spinner) - it's already the "right" label and we don't need to
  // wait on the SmartLink response. Only show the spinner when we have nothing
  // to display yet.
  const trimmedOverride = displayTextOverride?.trim();
  if (status === 'pending' && !trimmedOverride) {
    return <Spinner size="small" />;
  }
  const displayedTitle = trimmedOverride || title || fallback;
  return <React.Fragment>
			<ProviderIconView icon={providerIcon} />
			<Text>{displayedTitle}</Text>
		</React.Fragment>;
};